import { HttpErrorResponse } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "@bbj/components";
import { Observable, of, from } from "rxjs";
import { catchError, first } from "rxjs/operators";
import LoadingService from "../services/loading.service";

@Injectable()
export default class ErrorResolve {
  private authService = inject(AuthService);
  private loadingService = inject(LoadingService);


  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<void | string> {
    this.loadingService.start();

    return from(this.authService.login()).pipe(
      first(),
      catchError((error: HttpErrorResponse) => of()),
    );
  }
}
